var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUserflowRafiki(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-1"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "390 317 390 284.12 334.88 284.12 334.88 212.07 325.21 212.07 325.21 253.36 298.86 253.36 298.86 241.94 251.41 241.94 251.41 202.4 242.62 202.4 242.62 154.08 235.59 154.08 235.59 201.52 218.9 201.52 218.9 271.81 187.27 271.81 187.27 201.52 130.16 201.52 130.16 271.81 102.04 271.81 102.04 366.71 403.41 366.71 403.41 325 390 317",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "250.75 308 230.74 267 105.76 267 85.75 308 101 308 101 367 235 367 235 308 250.75 308",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 223,
    y: 313.38,
    width: 92.41,
    height: 53.62,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.85,
    y: 317,
    width: 75.91,
    height: 9.58,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.85,
    y: 331.09,
    width: 75.91,
    height: 9.58,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.85,
    y: 345.18,
    width: 75.91,
    height: 9.58,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.85,
    y: 359.27,
    width: 75.91,
    height: 7.73,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "213 308 97 308 83.76 267 63.75 308 79 308 79 367 129 367 213 316.33 213 308",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.38,
    y: 133.27,
    width: 6.76,
    height: 233.73,
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.76,
    cy: 150.23,
    r: 25.84,
    transform: "translate(204.24 540.5) rotate(-80.78)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.05,157.34l1.2-2.53a11.64,11.64,0,0,0,7.46,2.62c3.92,0,5.6-1.52,5.6-3.49,0-5.52-13.71-2-13.71-10.44,0-3.49,2.72-6.46,8.66-6.46a13.37,13.37,0,0,1,7.28,2l-1.07,2.59a11.68,11.68,0,0,0-6.21-1.84c-3.84,0-5.49,1.61-5.49,3.58,0,5.53,13.7,2.07,13.7,10.38,0,3.46-2.78,6.43-8.76,6.43C416.26,160.18,412.86,159,411.05,157.34Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 419.76,
    cy: 150.23,
    r: 22.55,
    transform: "translate(204.24 540.5) rotate(-80.78)",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-1"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-1",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Street--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M443,368.3V382H57V368.3a4.08,4.08,0,0,1,4-4.3H439A4.08,4.08,0,0,1,443,368.3Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 79,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 125,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 352,
    y: 364,
    width: 23,
    height: 18,
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397,
    y: 364,
    width: 24,
    height: 18,
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M443,368.3V382H57V368.3a4.08,4.08,0,0,1,4-4.3H439A4.08,4.08,0,0,1,443,368.3Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen3--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162,97.64v145a2.54,2.54,0,0,1-2.6,2.39H72.67c-1.24,0-1.67-.95-1.67-2.19V97.44c0-1.07.29-2.44,1.36-2.44H94a1.76,1.76,0,0,1,1.4,1.19l.89,2a1.38,1.38,0,0,0,1.4.78h36.91c.62,0,1.17-.09,1.4-.66l.9-2.29a1.58,1.58,0,0,1,1.39-1H159.7A2.75,2.75,0,0,1,162,97.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,97.64v145a2.54,2.54,0,0,1-2.6,2.39H72.67c-1.24,0-1.67-.95-1.67-2.19V97.44c0-1.07.29-2.44,1.36-2.44H94a1.76,1.76,0,0,1,1.4,1.19l.89,2a1.38,1.38,0,0,0,1.4.78h36.91c.62,0,1.17-.09,1.4-.66l.9-2.29a1.58,1.58,0,0,1,1.39-1H159.7A2.75,2.75,0,0,1,162,97.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 74.51,
    y: 110.99,
    width: 84,
    height: 104,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142,123.8h0a5.56,5.56,0,0,0-7.88,0h0a5.56,5.56,0,0,0,0,7.88l3.94,3.94,3.94-3.94A5.58,5.58,0,0,0,142,123.8Zm-2,5.84h0a2.7,2.7,0,0,1-3.81,0h0a2.69,2.69,0,0,1,0-3.8h0a2.7,2.7,0,0,1,3.81,0h0A2.69,2.69,0,0,1,140,129.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89.92,194.23h0a5.58,5.58,0,0,0-7.88,0h0a5.58,5.58,0,0,0,0,7.88L86,206.05l3.94-3.94A5.56,5.56,0,0,0,89.92,194.23Zm-2,5.84h0a2.67,2.67,0,0,1-3.8,0h0a2.69,2.69,0,0,1,0-3.8h0a2.69,2.69,0,0,1,3.8,0h0A2.69,2.69,0,0,1,87.88,200.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M146.44,111h-5.11l5.36,25.86-25.34,6.3L114.69,111h-5.12l6.92,33.37L89.66,151l-8.29-40H76.29l8.6,41.24-10.38,2.6V160L86,157.13l5.19,25.28-16.64,4.16v5.16l17.66-4.42L97.82,215h5.11l-6-28.88,7.12-1.77a1.75,1.75,0,0,1,1.41.22,1.81,1.81,0,0,1,.82,1.16l6.4,29.27h5.11l-6.62-30.33a6.84,6.84,0,0,0-8.33-5.18l-6.93,1.73-5.24-25.29,26.83-6.66,2.35,11.34a7.22,7.22,0,0,0,6.3,5.73l27.27,3,5.08,24.5v-29l-31.8-3.52a2.25,2.25,0,0,1-1.95-1.78l-2.4-11.54,36.15-9v-5.16l-7,1.73Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.05,235.16H98a6.43,6.43,0,0,1-6.43-6.42h0A6.43,6.43,0,0,1,98,222.31h37.07a6.43,6.43,0,0,1,6.42,6.43h0A6.43,6.43,0,0,1,135.05,235.16Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.19,229.08a3.49,3.49,0,1,1,3.5,3.36A3.34,3.34,0,0,1,99.19,229.08Zm6,0a2.55,2.55,0,1,0-2.54,2.53A2.46,2.46,0,0,0,105.23,229.08Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112,232.37l-1.41-2-.41,0h-1.63v2h-.94V225.8h2.57c1.7,0,2.74.86,2.74,2.29a2.08,2.08,0,0,1-1.45,2.07l1.56,2.21Zm0-4.28c0-.94-.63-1.48-1.83-1.48h-1.6v3h1.6C111.34,229.57,112,229,112,228.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.42,225.8h2.77a3.29,3.29,0,1,1,0,6.57h-2.77Zm2.71,5.75a2.48,2.48,0,1,0,0-4.94h-1.77v4.94Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.93,231.55v.82h-4.76V225.8h4.63v.81h-3.7v2h3.3v.8h-3.3v2.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M132.84,232.37l-1.42-2-.41,0h-1.62v2h-.94V225.8H131c1.71,0,2.74.86,2.74,2.29a2.07,2.07,0,0,1-1.44,2.07l1.55,2.21Zm0-4.28c0-.94-.63-1.48-1.83-1.48h-1.59v3H131C132.18,229.57,132.81,229,132.81,228.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162,157.65v84.71a2.65,2.65,0,0,1-2.64,2.64H143.67V164.15a6.5,6.5,0,0,1,6.5-6.5Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen2--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M242,176.64v145a2.55,2.55,0,0,1-2.61,2.39H152.66c-1.24,0-1.66-.95-1.66-2.19V176.44c0-1.07.27-2.44,1.35-2.44H174a1.76,1.76,0,0,1,1.4,1.19l.89,2a1.38,1.38,0,0,0,1.4.78h36.91c.61,0,1.17-.09,1.4-.66l.9-2.29a1.58,1.58,0,0,1,1.39-1.05h21.37A2.77,2.77,0,0,1,242,176.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,176.64v145a2.55,2.55,0,0,1-2.61,2.39H152.66c-1.24,0-1.66-.95-1.66-2.19V176.44c0-1.07.27-2.44,1.35-2.44H174a1.76,1.76,0,0,1,1.4,1.19l.89,2a1.38,1.38,0,0,0,1.4.78h36.91c.61,0,1.17-.09,1.4-.66l.9-2.29a1.58,1.58,0,0,1,1.39-1.05h21.37A2.77,2.77,0,0,1,242,176.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.82,
    y: 189.9,
    width: 84.67,
    height: 25.85,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 153.82,
    y: 217.75,
    width: 84.67,
    height: 98.58,
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.57,196.41V198h2.25v.55h-2.25v1.82h-.64v-4.49h3.16v.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169,200.34,168,199h-1.39v1.37H166v-4.49h1.75c1.16,0,1.87.59,1.87,1.56a1.41,1.41,0,0,1-1,1.42l1.06,1.51Zm0-2.93c0-.64-.43-1-1.25-1h-1.09v2h1.09C168.55,198.43,169,198.05,169,197.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M170.29,198.09a2.39,2.39,0,1,1,2.39,2.3A2.28,2.28,0,0,1,170.29,198.09Zm4.13,0a1.75,1.75,0,1,0-1.74,1.73A1.68,1.68,0,0,0,174.42,198.09Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.2,200.34v-3.27l-1.62,2.72h-.3l-1.62-2.7v3.25H176v-4.49h.53l1.87,3.15,1.85-3.15h.52v4.49Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,277.11c0,3.44-11.19,6.23-25,6.23s-25-2.79-25-6.23,11.19-6.22,25-6.22S221.15,273.67,221.15,277.11Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.15,277.11c0,3.44-11.19,6.23-25,6.23s-25-2.79-25-6.23,11.19-6.22,25-6.22S221.15,273.67,221.15,277.11Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.57,233.66h0a19,19,0,0,0-26.84,0h0a19,19,0,0,0,0,26.83l13.42,13.42,13.42-13.42A19,19,0,0,0,209.57,233.66Zm-6.94,19.89h0a9.16,9.16,0,0,1-13,0h0a9.15,9.15,0,0,1,0-13h0a9.16,9.16,0,0,1,13,0h0A9.15,9.15,0,0,1,202.63,253.55Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M206.68,306.23H185.62a6.41,6.41,0,0,1-6.42-6.42h0a6.41,6.41,0,0,1,6.42-6.42h21.06a6.41,6.41,0,0,1,6.42,6.42h0A6.41,6.41,0,0,1,206.68,306.23Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.73,302.69l.35-.73a3.36,3.36,0,0,0,2.16.76c1.14,0,1.63-.44,1.63-1,0-1.6-4-.59-4-3,0-1,.79-1.87,2.51-1.87a3.87,3.87,0,0,1,2.12.58l-.31.75a3.39,3.39,0,0,0-1.81-.54c-1.11,0-1.59.47-1.59,1.05,0,1.6,4,.6,4,3,0,1-.81,1.87-2.55,1.87A3.87,3.87,0,0,1,187.73,302.69Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.92,302.62v.82h-4.77v-6.57h4.64v.82h-3.7v2h3.3v.79h-3.3v2.12Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M201.74,297.69h-2.25v-.82h5.43v.82h-2.25v5.75h-.93Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242,242.33V176.64a2.65,2.65,0,0,0-2.64-2.64H223.67v61.83a6.5,6.5,0,0,0,6.5,6.5Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M162.82,206.41h-1.54v-.55H165v.55h-1.54v3.93h-.63Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.26,208.1a2.39,2.39,0,1,1,2.39,2.29A2.28,2.28,0,0,1,165.26,208.1Zm4.13,0a1.75,1.75,0,1,0-1.74,1.72A1.69,1.69,0,0,0,169.39,208.1Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M227.8,194.11H187.2a3.69,3.69,0,0,0-3.7,3.69h0a3.69,3.69,0,0,0,3.7,3.7h40.6a3.69,3.69,0,0,0,3.7-3.7h0A3.69,3.69,0,0,0,227.8,194.11Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M227.8,204.12H187.2a3.69,3.69,0,0,0-3.7,3.69h0a3.7,3.7,0,0,0,3.7,3.7h40.6a3.7,3.7,0,0,0,3.7-3.7h0A3.69,3.69,0,0,0,227.8,204.12Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Screen1--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M321,72.64v145a2.13,2.13,0,0,1-2.1,2.39H232.17a2.14,2.14,0,0,1-2.17-2.19V72.44c0-1.07.79-2.44,1.86-2.44h21.68a1.75,1.75,0,0,1,1.4,1.19l.9,2a1.37,1.37,0,0,0,1.39.78h36.92c.61,0,1.16-.09,1.39-.66l.9-2.29a1.59,1.59,0,0,1,1.4-1h21.37C320.39,70,321,71.45,321,72.64Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M321,72.64v145a2.13,2.13,0,0,1-2.1,2.39H232.17a2.14,2.14,0,0,1-2.17-2.19V72.44c0-1.07.79-2.44,1.86-2.44h21.68a1.75,1.75,0,0,1,1.4,1.19l.9,2a1.37,1.37,0,0,0,1.39.78h36.92c.61,0,1.16-.09,1.39-.66l.9-2.29a1.59,1.59,0,0,1,1.4-1h21.37C320.39,70,321,71.45,321,72.64Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 275.11,
    cy: 133.25,
    r: 33.25,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M308.5,133.25A33.25,33.25,0,1,1,275.25,100,33.19,33.19,0,0,1,308.5,133.25Z",
    style: {
      fill: "#fff",
      opacity: 0.4,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "280.25 122.73 274.53 122.73 275.36 120.36 279.42 120.36 280.25 122.73",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,144H246.87l1.34-8.67a2.66,2.66,0,0,1,2.3-2.24l10.78-1.38,6.51-7.46,0,0a3.24,3.24,0,0,1,1.85-1.07,43.26,43.26,0,0,1,7.68-.49,47.1,47.1,0,0,1,7.52.48c1,.15,2.13.75,2.13,1.63h0s.07.07.08.1l3,6.33-.08.09h0l.63.42,8.25,1.42a1.7,1.7,0,0,1,1.43,1.45Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.14,144H246.87l1.34-8.67a2.66,2.66,0,0,1,2.3-2.24l10.78-1.38,6.51-7.46,0,0a3.24,3.24,0,0,1,1.85-1.07,43.26,43.26,0,0,1,7.68-.49,47.1,47.1,0,0,1,7.52.48c1,.15,2.13.75,2.13,1.63h0s.07.07.08.1l3,6.33-.08.09h0l.63.42,8.25,1.42a1.7,1.7,0,0,1,1.43,1.45Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.09,144.24a4.68,4.68,0,1,1-4.67-4.68A4.67,4.67,0,0,1,262.09,144.24Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.75,144.24a2.34,2.34,0,1,1-2.33-2.34A2.33,2.33,0,0,1,259.75,144.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M295.83,144.24a4.67,4.67,0,1,1-4.67-4.68A4.67,4.67,0,0,1,295.83,144.24Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.5,144.24a2.34,2.34,0,1,1-2.34-2.34A2.33,2.33,0,0,1,293.5,144.24Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.13,
    y: 141.9,
    width: 6.01,
    height: 2.7,
    rx: 0.6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.44,
    y: 141.9,
    width: 5.07,
    height: 2.7,
    rx: 0.6,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88,139c0,1-.37,1.85-.82,1.85s-.82-.83-.82-1.85.36-1.85.82-1.85S249.88,138,249.88,139Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.45 141.17 298.98 141.17 298.98 137.13 300.11 137.13 300.45 141.17",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.02,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.6,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 253.18,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.75,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 256.33,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.9,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.48,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.06,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 262.63,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 264.21,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.78,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 267.36,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.94,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.51,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.09,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 273.66,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.24,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.82,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278.39,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.97,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.54,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.12,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 284.7,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 286.27,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.85,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.42,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.58,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.15,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 295.73,
    y: 137.13,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 297.31,
    y: 135.55,
    width: 1.58,
    height: 1.58,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,130.89v-6.58l5.42.1a1.69,1.69,0,0,1,1.52,1l2.47,5.48Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M264.89,130.89l4.51-5.54a2.77,2.77,0,0,1,2.17-1h4.76v6.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M268.93,124.31l-5.51,6.9s0,.23-2.13.51l6.51-7.47,0,0Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M290.41,131.21l-1.45-.32-3.28-6.26a8.42,8.42,0,0,1,1.32.15h0s.07.07.08.1Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.88,139c0,1-.37,1.85-.82,1.85s-.82-.83-.82-1.85.36-1.85.82-1.85S249.88,138,249.88,139Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "300.45 141.17 298.98 141.17 298.98 137.13 300.11 137.13 300.45 141.17",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M304.59,149c-5.6,10-16.64,17.59-29.34,17.59S251.51,159,245.91,149Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.67,115h-7.44a1.31,1.31,0,0,1-1.31-1.31h0a1.31,1.31,0,0,1,1.31-1.31h7.44a1.31,1.31,0,0,1,1.31,1.31h0A1.31,1.31,0,0,1,281.67,115Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.67,112.38a2.57,2.57,0,1,1-2.57-2.57A2.57,2.57,0,0,1,279.67,112.38Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 279.4,
    cy: 112.43,
    r: 1.43,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.47,125.33H293.9a1,1,0,0,1-1-1h0a1,1,0,0,1,1-1h5.57a1,1,0,0,1,1,1h0A1,1,0,0,1,299.47,125.33Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 296.05,
    cy: 123.36,
    r: 1.92,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 297.77,
    cy: 123.4,
    r: 1.07,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.45,124.93H249a1.31,1.31,0,0,1-1.31-1.31h0A1.32,1.32,0,0,1,249,122.3h7.45a1.32,1.32,0,0,1,1.31,1.32h0A1.31,1.31,0,0,1,256.45,124.93Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 251.88,
    cy: 122.3,
    r: 2.57,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 254.18,
    cy: 122.35,
    r: 1.43,
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.58,196.32H256.51a6.42,6.42,0,0,1-6.42-6.42h0a6.42,6.42,0,0,1,6.42-6.43h37.07A6.42,6.42,0,0,1,300,189.9h0A6.42,6.42,0,0,1,293.58,196.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M262.29,192.77l.35-.73a3.39,3.39,0,0,0,2.17.76c1.13,0,1.62-.44,1.62-1,0-1.61-4-.59-4-3,0-1,.79-1.88,2.52-1.88a3.94,3.94,0,0,1,2.11.58l-.31.75a3.46,3.46,0,0,0-1.8-.53c-1.12,0-1.6.47-1.6,1,0,1.61,4,.6,4,3,0,1-.81,1.87-2.54,1.87A3.9,3.9,0,0,1,262.29,192.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.93,187.77h-2.26V187h5.44v.81h-2.26v5.76h-.92Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278,191.88h-3.49l-.72,1.65h-1l3-6.57h.93l3,6.57h-1Zm-.33-.75-1.41-3.22-1.42,3.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M285.05,193.53l-1.41-2-.42,0H281.6v2h-.94V187h2.56c1.71,0,2.74.86,2.74,2.29a2.07,2.07,0,0,1-1.44,2.07l1.56,2.21Zm0-4.28c0-.94-.63-1.48-1.83-1.48h-1.6v3h1.6C284.4,190.73,285,190.18,285,189.25Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.69,187.77h-2.25V187h5.43v.81h-2.25v5.76h-.93Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396,258.17c-.19,4-26.71,10.33-30.12,8.33s0-29,0-29l20.43-4.17v0C386.69,234.1,396.21,254.24,396,258.17Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.5,236.5c-5.42,3.4-12.35-2.47-17.47-8.43a82.44,82.44,0,0,1-7.13-9.74l5.92-8.76,8.18,8.57h0l1.5,1.31-1-1.8-6.34-10L380.94,188l0,0S400.33,230.33,390.5,236.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.82,209.57l8.18,8.57h0c-1,4.53-3.45,8.24-7.18,9.92a82.44,82.44,0,0,1-7.13-9.74Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.56,217.66l-6.39-10L381,188v0S384,205.52,380.56,217.66Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.78,196.88l-9.68-2s-3.38-3.25-4.6-4.22-5.7-2.5-6.46-2.09,3.42,2.36,3.42,2.36-2,4.3-1.61,5.61,6.3,3,6.84,2.78l9.78,3.74Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.75 195.44 286.21 194.76 284.15 200.94 287.94 202.5 290.75 195.44",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "290.75 195.44 286.21 194.76 284.15 200.94 287.94 202.5 290.75 195.44",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "397.33 404.15 390.67 405.32 387.94 396.24 385.45 387.9 393.13 385.22 395.36 395.24 397.33 404.15",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "395.39 395.44 387.97 396.42 385.46 388 393.13 385.27 395.39 395.44",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.86 407 346.1 407 344.99 397.58 343.98 388.94 352.01 387.63 352.47 397.89 352.86 407",
    style: {
      fill: "#e4897b"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "352.47 398.1 344.99 397.77 343.98 389.03 352.01 387.68 352.47 398.1",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,390.16l-10.95,1.93c-11.05-27.53-18.91-50.51-24.46-69.58-3-10.29-5.32-19.44-7.11-27.56l.5,30V393H342.88C315.83,264,335,234.52,335,234.52L367.36,229a146.33,146.33,0,0,1,2.71,18.11l1.46,10.7,12.65,65.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5,
      isolation: "isolate"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M396,390.16l-10.95,1.93c-10.09-25.15-17.53-46.5-23-64.54l-1.5-5c-2.71-9.34-4.6-17.74-6.6-25.28v0a10.54,10.54,0,0,0-.51-2.26l.51,30V393H342.88c-16.52-78.79-15.8-120.45-12.74-140.95,2-13.07,4.86-17.53,4.86-17.53L367.36,229a146.33,146.33,0,0,1,2.71,18.11l.44,3.22,1,7.48,12.65,65.32Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "383.35 390.74 396.94 386.23 396.75 392.01 385.52 395.59 383.35 390.74",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "383.35 390.74 396.94 386.23 396.75 392.01 385.52 395.59 383.35 390.74",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.43 391.37 355.59 389.29 354.4 394.95 342.72 396.52 341.43 391.37",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "341.43 391.37 355.59 389.29 354.4 394.95 342.72 396.52 341.43 391.37",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.1,327.55l-1.5-5c-2.71-9.34-4.6-17.74-6.6-25.28v0l-1.15-13.88s6.91-15.25,4.32-26c.24.61,4.81,12.3,3,24A339,339,0,0,0,362.1,327.55Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M370.51,250.32l-40.37,1.73c2-13.07,4.86-17.53,4.86-17.53L367.36,229a146.33,146.33,0,0,1,2.71,18.11Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.1,173.35a1.57,1.57,0,0,1-.26.19,11.92,11.92,0,0,1-4.18,2.05c-4.42,1-7.44.41-9.41-1.59h0c-2.76-3-3.45-8.31-3.06-14.73a24.07,24.07,0,0,1,1.4-7.48s0-.1,0-.12.07-.19.11-.27a8.75,8.75,0,0,1,6.43-5.34,17.77,17.77,0,0,1,3.79-.42C373.43,145.51,375.68,166.21,366.1,173.35Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365.84,173.54a11.61,11.61,0,0,1-4.18,1.87c-4.42,1-7.44.27-9.41-1.76a12.46,12.46,0,0,0,7.93-.65C362,172.18,364,172.6,365.84,173.54Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.11,184.83c.77,3.56-3.84,5-3.84,5-7.54-3.22-8.94-7.23-8.94-7.23,6.29-3.28,4.47-12.56,4.47-12.56l1.28.63,9,1.76s-2.49,4.78-2.82,5.87v0C364.54,184,367.11,184.83,367.11,184.83Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.57,151.7s-.68,8.77,7.62,12.54c0,0,3.57,9.1,8.82,9.23,7.16.18,13.47-10,11-20.39C374.78,139.63,354.4,138.53,350.57,151.7Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.56,141.5s-13.62-3.75-15.48,5.75c-2.58,13.18,7.84,14.59,7.84,14.59s1.13,11-2.91,14.95c0,0,9.32,6.53,24.54,1.5,9.95-3.29.62-18.79.62-18.79S384.67,139.17,364.56,141.5Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,161.72c0-1.37,1.1-3.67,3.22-3.35s3.42,5.74-2,6.95C354.45,165.5,354,164.57,354,161.72Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.4,142.39s-6.73-1.72-8.57,6.61,4.29,11.48,4.29,11.48",
    style: {
      fill: "none",
      stroke: "#2e353a",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "0.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.56,181.6s7.29-3.93,15.28-1.18S372,188.5,372,188.5Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.56,181.6s7.29-3.93,15.28-1.18S372,188.5,372,188.5Z",
    style: {
      fill: "#fff",
      opacity: 0.5,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381,188s-6.91-2.71-13.1-4.41A104.33,104.33,0,0,0,353.2,181a97.31,97.31,0,0,0-14.08-.56c.14,2.26.23,4.4.32,6.41.12,2.65.2,5.11.26,7.39.11,4.28.1,7.94,0,11.2a109.64,109.64,0,0,1-2.56,21.07l-7,17L372,248.83l-2.38-16.67h0c7-20.22,9.92-30.87,11-36.91C381.92,188.52,381,188,381,188Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.12,180.47a23.16,23.16,0,0,1,.64,17S317,213.75,310.5,212.5s-24-9.33-24-9.33l2.75-8.21s20.25,4,22,4.79S339.12,180.47,339.12,180.47Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.4,186.3s9.77,29.89,12.1,54.63l-3.19-.41s-4.55-40.65-10.4-54.37Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.4,186.3s9.77,29.89,12.1,54.63l-3.19-.41s-4.55-40.65-10.4-54.37Z",
    style: {
      opacity: 0.2,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M386.34,233.35v0L373.17,236l4.33,29.65c8.49-1.75,18.4-5.06,18.52-7.5C396.21,254.24,386.69,234.1,386.34,233.35Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396,258.17c-2,1.43-5.66,3.83-9,.66s-.67-25.5-.67-25.5v0C386.69,234.1,396.21,254.24,396,258.17Z",
    style: {
      fill: "#fff",
      opacity: 0.1,
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.21,239s-2.09-46.61-6.65-53.43l1.35.58s6.41,7.35,8.23,52.85Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M335.6,421.73a10.84,10.84,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.26a4.15,4.15,0,0,1,4.43,1.72,2.7,2.7,0,0,1,.31.64,29.61,29.61,0,0,1,.52,3.61c.49,3.77.07,12.21.07,12.21h-.88l-.35-7.66c-.13-2.6-2.12.44-2.69,3.25s-1.78,5.77-7.48,5.92C336.68,423.62,333.92,423.36,335.6,421.73Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354,405.62c.32-2.6.42-7.12.42-7.12l-10.82,1.2s1.31,5.14.23,9C349.28,407.27,354,405.62,354,405.62Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M379.63,421.73a10.73,10.73,0,0,1,3.42-1.86h0s3.72-3.69,5.51-14.8l4.87-1.26a4.15,4.15,0,0,1,4.43,1.72,2.7,2.7,0,0,1,.31.64,29.61,29.61,0,0,1,.52,3.61c.49,3.77.07,12.21.07,12.21h-.88l-.35-7.66c-.13-2.6-2.12.44-2.69,3.25s-1.78,5.77-7.48,5.92C380.71,423.62,378,423.36,379.63,421.73Z",
    style: {
      fill: "#2e353a"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398,405.62c.32-2.6.42-7.12.42-7.12l-10.82,1.2s1.31,5.14.23,9C393.31,407.27,398,405.62,398,405.62Z",
    style: {
      fill: "#2e353a"
    }
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserflowRafiki);
export default __webpack_public_path__ + "static/media/User flow-rafiki.fcf3afa1d256e2c7237510a74e122bf8.svg";
export { ForwardRef as ReactComponent };